import axios, { Axios } from 'axios'
import { ArpeggiSupportedChain } from '../../types'
import { axiosConfig, DEV_NETWORKS, PROD_NETWORKS } from './constants'
import {
  ConstructorArgs,
  GetNFTsArgs,
  GetNFTsResponse,
  getOwnersForCollectionArgs,
  GetOwnersForCollectionResponse,
  IAlchemyClient,
  IsHolderOfCollectionArgs,
  IsHolderOfCollectionResponse
} from './types'

export class AlchemyClient implements IAlchemyClient {
  private apiKey: string
  private networks: Record<ArpeggiSupportedChain, string>
  private axiosInstance: Axios = axios.create(axiosConfig)

  constructor(args: ConstructorArgs) {
    this.apiKey = args.apiKey
    this.networks = args.isProd ? PROD_NETWORKS : DEV_NETWORKS
  }

  public async isHolderOfCollection(args: IsHolderOfCollectionArgs) {
    const { chain, ...params } = args
    const url = `${this.getAlchemyApiUrl(chain)}/isHolderOfCollection`

    return await this.axiosInstance.get<IsHolderOfCollectionResponse>(url, {
      params
    })
  }

  public async getOwnersForCollection({
    withTokenBalances = true,
    ...rest
  }: getOwnersForCollectionArgs) {
    const { chain, ...params } = rest
    const url = `${this.getAlchemyApiUrl(chain)}/getOwnersForCollection`

    return await this.axiosInstance.get<GetOwnersForCollectionResponse>(url, {
      params: { ...params, withTokenBalances }
    })
  }

  public async getNFTs(args: GetNFTsArgs) {
    const { chain, ...params } = args
    const url = `${this.getAlchemyApiUrl(chain)}/getNFTs`

    return await this.axiosInstance.get<GetNFTsResponse>(url, { params })
  }

  public getAlchemyApiUrl(chain: ArpeggiSupportedChain) {
    const alchemyChain = this.getAlchemyNetwork(chain)
    return `https://${alchemyChain}.g.alchemy.com/nft/v2/${this.apiKey}`
  }

  private getAlchemyNetwork(chain: ArpeggiSupportedChain) {
    return this.networks[chain]
  }
}
